import tokenRefresher from './idTokenRefresher';

// Start the token monitoring
export const initializeTokenRefresher = () => {
  tokenRefresher.startMonitoring();
};

// Stop the token monitoring (e.g., on logout)
export const stopTokenRefresher = () => {
  tokenRefresher.stopMonitoring();
};

// Export the refresher for direct access if needed
export default tokenRefresher;